import BaseModel from './BaseModel';
import Reference from './Reference';
import ReviewMember from './ReviewMember';
import { createDataExtractionValue } from './DataExtractionValue';

export default class DataExtractionReport extends BaseModel {
  constructor(data = {}) {
    super(DataExtractionReport, data);
    this.id = data.id;
    this.state = data.state;
    this.reference = data.reference
      ? new Reference(data.reference)
      : null;
    this.reviewer = data.reviewer
      ? new ReviewMember(data.reviewer)
      : null;
    this.values = data.values?.map(createDataExtractionValue) ?? [];
  }

  creationData() {
    return {
      id: this.id,
      state: this.state,
      reference: this.reference ? this.reference.id : null,
      reviewer: this.reviewer ? this.reviewer.id : null,
    };
  }
}
